/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rpe_Max_LabelInputs */

const fr_rpe_max_label = /** @type {(inputs: Rpe_Max_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RPE Max`)
};

/**

* @param {Rpe_Max_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const rpe_max_label = /** @type {((inputs?: Rpe_Max_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rpe_Max_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_rpe_max_label(inputs)
});